var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appbg"},[_c('title',{staticClass:"title-background"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"center"},[_c('div',{staticClass:"code_bg"},[_c('img',{staticClass:"iconappm",attrs:{"width":"560","height":"560","alt":"","src":_vm.url}}),_c('div',{staticClass:"codetit"},[_vm._v(_vm._s(_vm.codetit))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }